import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { Grid, Row, Col, Image } from 'react-bootstrap';
import partnerStyles from '../../../config/partnerStylesConfig';

const TitleImageContainer = partnerStyles.TitleImageContainer;

class TitleImage extends Component {
  render() {
    const backgroundImage = this.props.img;
    return (
      <TitleImageContainer>
        <div className="TitleImageContainer">
          <div className="ImageContainer" style={{ backgroundImage: 'url(' + backgroundImage + ')' }} />
          <div className="TitleContainer">
            <div className="Title primaryHeadingFonts">{this.props.title}</div>
            <div className="SubTitle secondaryHeadingFonts">{this.props.subtitle}</div>
          </div>
        </div>
      </TitleImageContainer>
    );
  }
}

export default TitleImage;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/shs/TitleImage/TitleImage.js